export default {
  actionInadimplencia({commit}, inadimplencia){
    commit("setInadimplencia", inadimplencia)
  }
}
